/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import { useLabel, useLabels } from '@/hooks/useLabels';
import ContentContainer from '@/components/AZCustomComponent/ContentContainer';
import styles from '../styles.module.scss';
import { getErrorDetails, getErrorMessage, isAxiosError } from '@/utils/errorsHandling';
import { type GenericATGErrorData } from '@/config/types';

type Props = {
  error?: unknown;
  onClick: () => void;
};

const labelMap = {
  label_items: 'label_ProductDisplayPage_body_Items',
};

export function AffinityErrorNotification({ error, onClick }: Props) {
  const labels = useLabels(labelMap);

  const amountOfUnavailableItems = getErrorDetails(error)?.length ?? 0;
  const axiosErrorData = isAxiosError(error)
    ? (error.response?.data as GenericATGErrorData | undefined)
    : undefined;
  const topLevelErrorMessageKey =
    axiosErrorData?.errorMessageKey ||
    axiosErrorData?.errorMessageDefault ||
    getErrorMessage(error) ||
    '';
  return (
    <div className={styles.notificationContainer}>
      <ContentContainer type="shadowed" withPadding withMargin className={styles.errorShadow}>
        <div className={styles.notificationMessage}>
          <div className={styles.iconAndText}>
            <span className={styles.errorIcon} />
            <div>
              <div className={styles.notificationTitle}>{`${amountOfUnavailableItems} ${
                labels.label_items
              } ${useLabel(topLevelErrorMessageKey)}`}</div>
              <div className={styles.notificationSubtitle}>
                {useLabel(getErrorDetails(error)?.at(0)?.errorMessageKey ?? '')}
              </div>
            </div>
          </div>
          <button className={styles.closeNotificationButton} onClick={onClick}>
            x
          </button>
        </div>
      </ContentContainer>
    </div>
  );
}
